import { httpClient } from "@services/api/httpClient";

export async function submitOfferAssessment(id: number, applicantId: number, answeredQuestions: Record<string, string>) {
  const response = await httpClient.post(`/offer-assesment/answered-questions`, { offerId: id, offerApplicantId: applicantId, answeredQuestions });
  return response.data;
}